import { useEffect } from "react";
import ReactGA from "react-ga4";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import PickupStudentCreateQRMobile from "./pickupStudentCreateQRMobile.jsx";
import { BrowserView, MobileView } from "react-device-detect";
const PickupStudentScanComponent = () => {
  const gaEventTracker = useAnalyticsEventTracker("ScanPickupStudent");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Scan Pickup Student",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <PickupStudentCreateQRMobile></PickupStudentCreateQRMobile>
      </BrowserView>
      <MobileView>
        <PickupStudentCreateQRMobile></PickupStudentCreateQRMobile>
      </MobileView>
    </>
  );
};

export default PickupStudentScanComponent;
